/* eslint-disable jsx-a11y/anchor-is-valid */
import {Fragment} from 'react'
import {KTIcon} from '../../../../helpers'

type Props = {
  className: string
}

const rows: Array<{description: string}> = [
  {description: 'Avg. Client Rating'},
  {description: 'Instagram Followers'},
  {description: 'Google Ads CPC'},
]

const ListsWidget26 = ({className}: Props) => (
  <div className={`card card-flush ${className}`}>
    <div className='pt-5 card-header'>
      <h3 className='text-gray-800 card-title fw-bold'>External Links</h3>
      <div className='card-toolbar'></div>
    </div>
    <div className='pt-5 card-body'>
      {rows.map((row, index) => (
        <Fragment key={`lw26-rows-${index}`}>
          <div className='d-flex flex-stack'>
            <a href='#' className='text-primary fw-semibold fs-6 me-2'>
              {row.description}
            </a>
            <button
              type='button'
              className='h-auto btn btn-icon btn-sm btn-color-gray-400 btn-active-color-primary justify-content-end'
            >
              <KTIcon iconName='exit-right-corner' className='fs-2' />
            </button>
          </div>
          {rows.length - 1 > index && <div className='my-3 separator separator-dashed' />}
        </Fragment>
      ))}
    </div>
  </div>
)
export {ListsWidget26}
